type State = {
  additional_form_modal: {
    open: boolean;
  };
};

type Action =
  | {
      type: "open-additional-form-modal";
    }
  | {
      type: "close-additional-form-modal";
    }
  | {
      type: "reset";
    };

export function init(state: Partial<State>): State {
  return {
    additional_form_modal: {
      open: !!state.additional_form_modal,
    },
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "open-additional-form-modal":
      return {
        ...state,
        additional_form_modal: {
          open: true,
        },
      };
    case "close-additional-form-modal":
      return {
        ...state,
        additional_form_modal: {
          open: false,
        },
      };
    case "reset":
      return init({});
    default:
      return state;
  }
}
